import { useContext } from 'react';

import { AiActivityCitationsContext } from '../AiActivityCitations.context';

export const useAiActivityCitations = () => useContext(AiActivityCitationsContext);
